import React from "react";
import { useTranslation } from "react-i18next";

const Loading = ({ titleText, text }) => {
  const { t } = useTranslation();

  return (
    <div className="text-2xl h-[90vh] justify-center items-center mx-auto w-full flex flex-col">
      <h1 className="text-[28px] text-[#003E6F] font-bold">{titleText || t("loading")}</h1>
    </div>
  );
};

export default Loading;
